// Shortcode -> emoji conversion, mirroring the mobile app's emojiShortcode util.
// The backend stores a savings-goal icon as a shortcode (e.g. `:snowman:`) and the
// UI needs the emoji (`⛄`). We ship a compact pre-generated map (see emojiShortcodeMap)
// instead of the full ~404KB emoji dataset to keep the public payment bundle small.
import EMOJI_SHORTCODE_MAP from './emojiShortcodeMap';

const SHORTCODE_TO_EMOJI = new Map<string, string>(
  Object.entries(EMOJI_SHORTCODE_MAP),
);

const hasColons = (value: string): boolean =>
  value.length > 1 && value.startsWith(':') && value.endsWith(':');

const stripColons = (value: string): string =>
  hasColons(value) ? value.slice(1, -1) : value;

/**
 * Converts a backend shortcode (e.g. `:snowman:`) to its emoji (e.g. `⛄`).
 * Returns an empty string for empty input, and the input unchanged when the
 * shortcode is unknown (so already-emoji values pass through untouched).
 */
export const shortcodeToEmoji = (shortcode?: string | null): string => {
  if (!shortcode) return '';
  return SHORTCODE_TO_EMOJI.get(stripColons(shortcode)) ?? shortcode;
};
